import { render, staticRenderFns } from "./fcwpSocial.vue?vue&type=template&id=38c4b420&scoped=true&"
import script from "./fcwpSocial.vue?vue&type=script&lang=js&"
export * from "./fcwpSocial.vue?vue&type=script&lang=js&"
import style0 from "./fcwpSocial.vue?vue&type=style&index=0&id=38c4b420&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4b420",
  null
  
)

export default component.exports